import { GlCollapsibleListbox, GlTooltipDirective, GlButtonGroup, GlButton, GlToastMixin } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import Api from '../../api.js?vue3';
import { sprintf } from '~/locale';
import { CUSTOM_LEVEL, i18n } from '../constants';
import CustomNotificationsModal from './custom_notifications_modal.vue?vue3';
export default {
    name: 'NotificationsDropdown',
    components: {
        GlCollapsibleListbox,
        GlButtonGroup,
        GlButton,
        CustomNotificationsModal
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        GlToastMixin
    ],
    inject: {
        containerClass: {
            default: ''
        },
        emailsDisabled: {
            default: false
        },
        dropdownItems: {
            default: []
        },
        buttonSize: {
            default: 'medium'
        },
        buttonCategory: {
            default: 'primary'
        },
        initialNotificationLevel: {
            default: ''
        },
        projectId: {
            default: null
        },
        groupId: {
            default: null
        },
        showLabel: {
            default: false
        }
    },
    data () {
        return {
            selectedNotificationLevel: this.initialNotificationLevel,
            isLoading: false,
            notificationsModalVisible: false
        };
    },
    computed: {
        notificationLevels () {
            const levels = this.dropdownItems.map((level)=>({
                    value: level,
                    text: this.$options.i18n.notificationTitles[level] || '',
                    secondaryText: this.$options.i18n.notificationDescriptions[level] || ''
                }));
            return [
                {
                    text: '',
                    options: levels
                },
                {
                    text: this.$options.i18n.notificationTitles.custom,
                    textSrOnly: true,
                    options: [
                        {
                            value: this.$options.customLevel,
                            text: this.$options.i18n.notificationTitles.custom,
                            secondaryText: this.$options.i18n.notificationDescriptions.custom
                        }
                    ]
                }
            ];
        },
        isCustomNotification () {
            return this.selectedNotificationLevel === CUSTOM_LEVEL;
        },
        buttonIcon () {
            if (this.isLoading) {
                return '';
            }
            return this.selectedNotificationLevel === 'disabled' ? 'notifications-off' : 'notifications';
        },
        buttonText () {
            const notificationTitle = this.$options.i18n.notificationTitles[this.selectedNotificationLevel] || this.selectedNotificationLevel;
            if (this.showLabel) {
                return notificationTitle;
            }
            return this.emailsDisabled ? this.$options.i18n.notificationDescriptions.owner_disabled : sprintf(this.$options.i18n.notificationTooltipTitle, {
                notification_title: notificationTitle
            });
        },
        ariaLabel () {
            return sprintf(this.$options.i18n.notificationTooltipTitle, {
                notification_title: this.$options.i18n.notificationTitles[this.selectedNotificationLevel]
            });
        }
    },
    methods: {
        openNotificationsModal () {
            if (this.isCustomNotification) {
                this.notificationsModalVisible = true;
            }
        },
        selectItem (level) {
            if (level !== this.selectedNotificationLevel) {
                this.updateNotificationLevel(level);
            }
        },
        async updateNotificationLevel (level) {
            this.isLoading = true;
            try {
                await Api.updateNotificationSettings(this.projectId, this.groupId, {
                    level
                });
                this.selectedNotificationLevel = level;
                this.openNotificationsModal();
            } catch (error) {
                this.$toast.show(this.$options.i18n.updateNotificationLevelErrorMessage);
            } finally{
                this.isLoading = false;
            }
        }
    },
    customLevel: CUSTOM_LEVEL,
    i18n,
    modalId: 'custom-notifications-modal'
};
